import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { cloneDeep } from 'lodash-es';
import { MessageService } from 'primeng/api';
import { catchError, delay, firstValueFrom, forkJoin, map, Observable, of, switchMap } from 'rxjs';
import { AssignmentDTO } from '../../../../app/shared/models/Assignment';
import { AssignmentGroupSharedDataService } from '../../../../app/shared/services/assignment-group-shared-data.service';
import { CourseConstants } from '../../constants/course.constants';
import { Session } from '../../models/session';
import { CourseService } from '../../services/course.service';
import { SessionAttachmentDetails } from '../../models/session-attachment-details';
import { SessionDetails } from '../../models/session-details';
import { UserType } from '../../../../app/shared/enums/user-type';
import { UsersService } from '../../../../app/shared/services/users.service';
import { CommonService } from '../../../../app/shared/services/common.service';
import { SharedConstants } from '../../../../app/shared/constants/shared-constants';


@Component({
  selector: 'app-session-slider',
  templateUrl: './session-slider.component.html',
  styleUrls: ['./session-slider.component.scss']

})
export class SessionSliderComponent implements OnInit {
  @Input() isAddSessionSliderOpen!: boolean;
  @Input() courseDetailsData: any;
  @Input() sessionId: any;
  @Output() isSessionManagementDataReload = new EventEmitter<boolean>();
  sessionSliderHeader: string = CourseConstants.Session_Slider_Heder_Text;
  sessionForm!: FormGroup;
  errorIconClassForTab = '';
  sessionBindData: any = {};
  serviceSessionData: any = {};
  valueField: string = 'value';
  labelField: string = 'name';
  usersAndAssignmentGroupList: any = [];
  userList: any = [];
  errorMessageHeaderText: string =
    CourseConstants.Session_Error_Message_Header_Text;
  errorMessages: string[] = [];
  mandatoryFields = this.getDefaultMandatoryFieldsObject();
  isUpload: boolean = false;
  files: File[] = [];
  fileNamesForAddAndDeleteOperations: string[] = [];
  disableFileUploader!: any;
  fileName!: string;
  fileType!: string;
  maxFileSize = CourseConstants.Attachment_File_Max_Size;
  savedFiles: string[] = [];
  maxFileLimit = CourseConstants.Attachments_File_Max_Limit;
  ifFormatIsInPerson: boolean = false;
  ifFormatIsVirtual: boolean = false;
  assignmentGroupsDataOfTheCourse: any;
  sessionDetails !: Session
  fileNames: string[] = [];
  sessionStatusList: any;
  errorText: any;
  sessionInfo!: SessionDetails | null;
  sesionDetailsForEdit!: SessionDetails | null;
  qualifiedTrainersNameList: string[] = [];
  qualifiedTrainersFinalList: any;
  usersAndAssignmentGroupListForSession: any;
  isInActiveAssignmentGroupDialog: boolean = false;
  isSessionEdit: boolean = false;
  deleteAttachmentId: any;
  courseQualifiedUsersList: any;
  sessionAttachments: any;
  fileUploadedEnabled: boolean = false;
  showDeleteAttachmentConfirmationModal: boolean = true;
  qualifiedTrainersData: any;
  assignedInternalTrainersList: any = [];
  filesToSave: SessionAttachmentDetails[] = [];
  deletedAttachments: SessionAttachmentDetails[] = [];
  deletedAttachmentsForConfirmation: SessionAttachmentDetails[] = [];
  attachmentsMarkedForDeletion: SessionAttachmentDetails[] = [];
  showDeletedFilesConfirmationModal: boolean = false;
  deleteAttachmentConfirmationMessage: string =
    CourseConstants.Deleted_Attachments_Confirmation_Message;
  filesToDelete: string[] = [];
  uploadedResponses: any = []

  internalTrainersFinalList: any = [];
  internalTrainersWithInactiveUsers: any = [];
  usersListToValidate: any = [];
  validatedUsersList: any = [];
  inactiveGroupsSelected: any = [];
  InactiveAssignmentGroupField: any;

  constructor(private courseService: CourseService,
    private _formBuilder: FormBuilder,
    private messageService: MessageService,
    private assignmentGroupSharedDataService: AssignmentGroupSharedDataService, private usersService: UsersService
  ,private commonService: CommonService) { }

  ngOnInit() {
    this.courseService.closeAndResetSessionSlider$.subscribe((isClose) => {
      if (isClose) { this.closeAndResetSessionSlider(); this.errorIconClassForTab = ''; }
    })
    this.isSessionEdit = this.courseService.getSessionSliderStatus();
    this.sessionSliderHeader = this.isSessionEdit ? CourseConstants.Session_Slider_Heder_Text_For_Edit :
      CourseConstants.Session_Slider_Heder_Text;
    this.fileUploadedEnabled = !this.isSessionEdit;
    this.sessionForm = this.createFormGroupWithBuilderAndModel();
    this.initialize();
    if (!this.isSessionEdit) {
      this.setSessionSliderToDefaults();
    }
    this.onFormControlChanges();
  }

  private onFormControlChanges() {
    let formValues = this.sessionForm.getRawValue();
    this.sessionForm
      ?.get('sessionFormat')
      ?.valueChanges.subscribe((sessionFormatValue) => {
        if (sessionFormatValue == CourseConstants.session_Format_InPerson_Value) {
          this.disableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
          this.sessionForm.patchValue({
            virtualMeetingURL: null
          })
          this.ifFormatIsInPerson = false;
        }
        else {
          this.enableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
          this.ifFormatIsInPerson = true;
        }
        if (sessionFormatValue == CourseConstants.Session_Format_Virtual_Value) {
          this.disableControls(CourseConstants.SessionFormControls_Room);
          this.sessionForm.patchValue({
            room: null
          })
          this.ifFormatIsVirtual = false;
        }
        else {
          this.enableControls(CourseConstants.SessionFormControls_Room);
          this.ifFormatIsVirtual = true;
        }
      });

    this.sessionForm
      ?.get('startDateTime')
      ?.valueChanges.subscribe((sessionStartDateAndTime) => {
        let startDatevalue = new Date(sessionStartDateAndTime);
        let enddateValue: Date = new Date(startDatevalue.setHours(startDatevalue.getHours() + 1));
        this.sessionForm.patchValue({
          endDateTime: enddateValue
        })
      }
      );
  }

  disableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach(controlName => {
      this.sessionForm.controls[controlName].disable();
    });
  }
  enableControls(controlNames: string | string[]) {
    if (typeof controlNames === 'string') {
      controlNames = [controlNames];
    }
    controlNames.forEach(controlName => {
      this.sessionForm.controls[controlName].enable();
    });
  }

  setSessionSliderToDefaults() {
    if (!!this.sessionForm) {
      this.sessionForm.patchValue({
        sessionFormat: CourseConstants.session_Format_InPerson_Value,
        enrollment: CourseConstants.Session_Enrollment_Open,
      })
      this.disableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
      this.sessionForm.patchValue({
        virtualMeetingURL: null
      })
      this.ifFormatIsInPerson = false;
      this.ifFormatIsVirtual = true;
    }
    else {
      this.enableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
      this.ifFormatIsInPerson = true;
      this.ifFormatIsVirtual = false;
    }
  }

  async initialize() {
    this.assignmentGroupsDataOfTheCourse = [];
    this.usersAndAssignmentGroupList = [];
    let internalTrainerLookup = await firstValueFrom(this.courseService.getSessionInternalTrainerData(this.courseDetailsData.courseNumber));
      
        if (internalTrainerLookup !== null && internalTrainerLookup.internalTrainers !== null) {
          for (let dataItem of internalTrainerLookup.internalTrainers) {
            if (this.isSessionEdit && ((dataItem.assignmentType === CourseConstants.AssignmentGroupType) || dataItem.assignmentType === 1)) {
              this.usersAndAssignmentGroupList.push({
                value: dataItem.assignedUserName,
                name: dataItem.assignedUserName,
                type: dataItem.assignmentType,
                assignmentId: dataItem.assignmentId,
                isactive: dataItem.isActive
              });
            }
            else {
              if ((dataItem.assignmentType === CourseConstants.AssignmentGroupType && dataItem.isActive === true)
                || (dataItem.assignmentType === 1 && dataItem.isActive === true)) {
                this.usersAndAssignmentGroupList.push({
                  value: dataItem.assignedUserName,
                  name: dataItem.assignedUserName,
                  type: dataItem.assignmentType,
                  assignmentId: dataItem.assignmentId,
                  isactive: dataItem.isActive
                });
              }
            }
          }
        }

        this.userList = [...this.usersAndAssignmentGroupList];
    // Convert the observable to a promise and await its resolution
    const serviceData = await firstValueFrom(this.courseService.getSessionMasterData());

    // Clone the service data
    this.serviceSessionData = cloneDeep(serviceData);

    // Call the method to create data
    this.createData();

    // Load the edit session slider and await its completion
    await this.loadEditSessionSlider();
  }

  async loadEditSessionSlider() {
    this.sessionInfo = this.courseService.getCurrentSession();
    await this.setValueForEditSlider();
  }
  async setValueForEditSlider() {
    if (this.sessionInfo !== null) {
      this.constructEditCourseDetails();
      this.usersAndAssignmentGroupListForSession = [];
      if (this.sesionDetailsForEdit !== null) {

        await this.processUsersList();

        this.calculateSavedFiles();
        this.sessionForm.patchValue({
          startDateTime: this.commonService.parseCustomDate(this.sesionDetailsForEdit?.startDateAndTime),
          endDateTime: this.commonService.parseCustomDate(this.sesionDetailsForEdit?.endDateAndTime),
          timeZone: this.sesionDetailsForEdit?.timeFormatValue,
          enrollment: this.sesionDetailsForEdit?.enrollmentValue,
          sessionFormat: this.sesionDetailsForEdit?.formatValue,
          InternalTrainers: this.sesionDetailsForEdit?.internalTrainers != null || this.sesionDetailsForEdit?.internalTrainers != undefined ? this.sesionDetailsForEdit?.internalTrainers.map((obj: { assignedUserName: any; }) => obj.assignedUserName) : null,
          externalTrainers: this.sesionDetailsForEdit?.externalTrainers,
          room: (this.sesionDetailsForEdit.formatValue === CourseConstants.Session_Format_Virtual_Value) ? null : this.sesionDetailsForEdit?.room,
          virtualMeetingURL: (this.sesionDetailsForEdit.formatValue === CourseConstants.session_Format_InPerson_Value) ? null : this.sesionDetailsForEdit?.virtualMeetingURL,
          attachments: this.sesionDetailsForEdit?.attachments !== null ? this.sesionDetailsForEdit?.attachments : null
        },
          { emitEvent: false, onlySelf: true });
        this.enableOrDisableControlsByFormatInptut(this.sesionDetailsForEdit.formatValue);
      }
    }
  }

  async processUsersList() {
    if (!this.isSessionEdit) {
      this.internalTrainersWithInactiveUsers = [...this.usersAndAssignmentGroupList];
    }
    else {
      this.internalTrainersWithInactiveUsers = [...this.usersAndAssignmentGroupList];
      this.usersListToValidate = [];

      this.usersListToValidate.push({
        userType: UserType.InternalTrainers,
        userAssignmentList: this.sesionDetailsForEdit?.trainers
      });

      // Fetch and process the validated users list
      this.validatedUsersList = await firstValueFrom(this.usersService.validateUsers(this.usersListToValidate));

      if (this.validatedUsersList.length > 0) {
        // Iterate through each userInfo in the validatedUsersList
        this.validatedUsersList.forEach((userInfo: { userAssignmentList: any[]; userType: any; }) => {
          // Filter only inactive user types for binding dropdown lists
          const filteredAssignments = userInfo.userAssignmentList.filter(assignment => assignment.assignmentType != 0);

          // Determine the target list based on user type
          let targetList: { name: string, value: string }[] = [];

          switch (userInfo.userType) {
            case UserType.InternalTrainers:
              targetList = this.internalTrainersWithInactiveUsers;
              break;
            default:
              return; // Skip unknown user types
          }

          // Add filtered assignments to the target list
          filteredAssignments.forEach(user => {
            const userItem = { name: user.assignedUserName, value: user.assignedUserName };

            // Check if the item already exists in the target list
            if (!targetList.some(item => item.name === userItem.name && item.value === userItem.value)) {
              targetList.push(userItem);
            }
          });
        });
      }

      this.usersAndAssignmentGroupList = [...this.internalTrainersWithInactiveUsers];
    }
  }



  createFormGroupWithBuilderAndModel() {
    return this._formBuilder.group({
      startDateTime: new FormControl('', [Validators.required]),
      endDateTime: new FormControl('', [Validators.required]),
      timeZone: new FormControl(null, [Validators.required]),
      enrollment: new FormControl(null, [Validators.required]),
      sessionFormat: new FormControl(null, [Validators.required]),
      InternalTrainers: new FormControl(null, [Validators.required]),
      externalTrainers: new FormControl(null, [Validators.required]),
      room: new FormControl(null, [Validators.required]),
      virtualMeetingURL: new FormControl('', [Validators.required]),
    })
  }

  GetQualifiedTrainersNames(qualifiedTrainersInfo: AssignmentDTO[] | undefined): any {
    this.qualifiedTrainersNameList = [];
    qualifiedTrainersInfo?.filter((assignment: any) => {
      if (this.qualifiedTrainersNameList.indexOf(assignment.assignedUserName) === -1)
        this.qualifiedTrainersNameList.push(assignment.assignedUserName);
    });
    return this.qualifiedTrainersNameList;
  };

  private constructEditCourseDetails() {
    this.sesionDetailsForEdit = JSON.parse(
      JSON.stringify(this.sessionInfo)
    );
  }
  createData() {
    this.sessionBindData.enrollments = this.serviceSessionData.enrollment;
    this.sessionBindData.timeZones = this.serviceSessionData.timeZone;
    this.sessionBindData.formats = this.serviceSessionData.format;
    this.sessionStatusList = this.serviceSessionData.statuses;
  }

  private validateForm() {
    this.errorMessages = [];
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    if (this.sessionForm.invalid) {
      Object.keys(this.sessionForm.controls).forEach((key) => {
        if (this.sessionForm.get(key)?.errors) {
          let errorText = this.getErrorMessageText(key);
          if (errorText !== "" || '')
            this.errorMessages.push(errorText);
        }
      });
    }
    this.validateTimeInformation();
    this.validateUserInformation();
  }

  validateUserInformation() {
    let formValues = this.sessionForm.getRawValue();
    if ((formValues.InternalTrainers === null || formValues.InternalTrainers === undefined || formValues.InternalTrainers.length <= 0)
      && (formValues.externalTrainers === null || formValues.externalTrainers === undefined || formValues.externalTrainers === " " || formValues.externalTrainers === "")) {
      this.errorText = CourseConstants.Session_TainersCannotBeNull
      this.errorMessages.push(this.errorText);
      this.mandatoryFields.InternalTrainers = true;
      this.mandatoryFields.externalTrainers = true;
    }
  }
  validateTimeInformation() {
    let formValues = this.sessionForm.getRawValue();
    if (formValues.startDateTime > formValues.endDateTime) {
      this.errorText = CourseConstants.Session_StartTimeShouldBe;
      this.errorMessages.push(this.errorText);
    }
  }

  private getDefaultMandatoryFieldsObject() {
    return {
      startDateTime: false,
      endDateTime: false,
      timeZone: false,
      enrollment: false,
      format: false,
      room: false,
      virtualMeetingURL: false,
      InternalTrainers: false,
      externalTrainers: false
    };
  }
  private getErrorMessageText(labelName: string) {
    this.errorText = '';
    switch (labelName) {
      case 'startDateTime':
        this.errorText = CourseConstants.Session_StartDateTime_Required;
        this.mandatoryFields.startDateTime = true;
        break;
      case 'endDateTime':
        this.errorText = CourseConstants.Session_EndDateTime_Required;
        this.mandatoryFields.endDateTime = true;
        break;
      case 'timeZone':
        this.errorText = CourseConstants.Session_Time_Zone_Required;
        this.mandatoryFields.timeZone = true;
        break;
      case 'enrollment':
        this.errorText = CourseConstants.Session_Enrollment_Required;
        this.mandatoryFields.enrollment = true;
        break;
      case 'sessionFormat':
        this.errorText = CourseConstants.Session_Format_Required;
        this.mandatoryFields.format = true;
        break;
      case 'room':
        this.errorText = CourseConstants.Session_Room_Required;
        this.mandatoryFields.room = true;
        break;
      case 'virtualMeetingURL':
        this.errorText = CourseConstants.Session_VirtualMeetingURL_Required;
        this.mandatoryFields.virtualMeetingURL = true;
        break;
      case 'InternalTrainers':
        this.errorText = ''
        break;
      case 'externalTrainers':
        this.errorText = ''
        break;
    }
    return this.errorText;
  }


  async saveSession() {
    this.validateForm();
    await this.processUsersList();
    this.mapSessionToSession();
    if (this.errorMessages.length == 0) {
      this.prepareAddedAttachments();
      if (!this.isSessionEdit) {
        this.courseService.saveSessionForCourse(this.sessionDetails).subscribe(data => {
          this.saveFiles(data.sessionId, data.parentCourseNumber)
        });

      }
      else {
        this.prepareDeletedAttachments();
        this.showConfirmationPopupForDeletedAttachments();
        if (!this.showDeletedFilesConfirmationModal) {
          this.verifyIfCourseContainsInActiveAGForUpdate(this.sessionDetails);
        }
      }
    }
  }

  verifyIfCourseContainsInActiveAGForUpdate(sessionDetailsInfo: Session) {
    let userListToValidate = this.userList;

    // Extract non-terminated users and map them to the desired structure
    const nonTerminatedUserList = this.validatedUsersList
      .flatMap((user: any) => user.userAssignmentList || [])
      .filter((user: any) => !user.isTerminated)
      .map((user: any) => ({
        value: user.value,
        name: user.assignedUserName,
        type: user.assignmentType,
        assignmentId: user.assignmentId,
        isactive: user.isActive,
      }));
    userListToValidate = userListToValidate.concat(nonTerminatedUserList);
    this.inactiveGroupsSelected = this.assignmentGroupSharedDataService.findInactiveObjectsInValidatedList(sessionDetailsInfo.internalTrainers, this.validatedUsersList,
      userListToValidate
    );
    if (this.inactiveGroupsSelected != undefined && this.inactiveGroupsSelected.length > 0) {
      this.isInActiveAssignmentGroupDialog = true;
      this.InactiveAssignmentGroupField = this.inactiveGroupsSelected;
    }
    else
      this.saveSessionWithInactiveAssignmentGroup();
  }

  saveSessionWithInactiveAssignmentGroup() {
    this.isInActiveAssignmentGroupDialog = false;
    this.courseService.updateSessionForCourse(this.sessionDetails).subscribe(data => {
      this.saveFiles(data.sessionId, data.parentCourseNumber);
    });
  }
  closeConfirmationDailog(value: boolean) {
    this.isInActiveAssignmentGroupDialog = value
  }

  mapSessionToSession() {
    let formValues = this.sessionForm.getRawValue();
    this.sessionDetails = {
      parentCourseNumber: this.courseDetailsData.courseNumber,
      startDateTime: this.formatDateTimeToISOString(formValues.startDateTime),
      endDateTime: this.formatDateTimeToISOString(formValues.endDateTime),
      timeFormat: formValues.timeZone,
      enrollment: formValues.enrollment,
      internalTrainers: this.assignmentGroupSharedDataService.updateUserToAssignmentTypeArrayForSession(formValues.InternalTrainers, this.internalTrainersWithInactiveUsers),
      externalTrainers: formValues.externalTrainers,
      status: this.getStatusForCreateSession(),
      format: formValues.sessionFormat,
      room: formValues.room,
      virtualMeetingURL: formValues.virtualMeetingURL,
    }
  }

  getStatusForCreateSession(): any {
    return this.sessionStatusList.find((obj: { name: string; }) =>
      obj.name === CourseConstants.Session_Status_Scheduled).value;
  }
  closeSlider() {
    this.isSessionEdit = false;
    this.courseService.openConfirmationDialogForSession();
  }

  closeAndResetSessionSlider() {
    this.sessionForm.reset();
    this.errorMessages = [];
    this.courseService.setSessionSliderStatus(false);
    this.mandatoryFields = this.getDefaultMandatoryFieldsObject();
    this.files = [];
    this.savedFiles = [];
    this.fileNamesForAddAndDeleteOperations = [];
    this.deletedAttachments = [];
    this.attachmentsMarkedForDeletion = [];
    this.filesToDelete = [];
    this.setSessionSliderToDefaults();
  }

  // files

  uploadSucceeds = (uploadedFiles: File[]): Observable<string[]> => {
    this.files = [...this.files, ...uploadedFiles];
    uploadedFiles.forEach((file) => {
      this.fileNamesForAddAndDeleteOperations.push(file.name);
    });
    const fileNames = uploadedFiles.map((i) => i.name);
    return of(fileNames).pipe(delay(3000));
  };

  deleteFile = (fileName: string): Observable<boolean> => {
    this.deleteAttachment(fileName);
    return of(true);
  };


saveFiles = (sessionId: string, courseNumber: string) => {
  this.filesToSave = [];
  let successMessage = CourseConstants.Session_Created_Success;

  const uploadFiles = () => {
    if (this.files.length === 0) {
      this.showConfirmationMessage(CourseConstants.Severity_Success, successMessage);
      this.isSessionManagementDataReload.emit(true);
      this.courseService.closeAndResetSessionSlider$.next(false);
    } else {
      let completedUploads = 0;

      this.files.forEach((file: File) => {
        const modifiedFile = new File(
          [file],
          courseNumber + '_' + sessionId + '/' + file.name,
          { type: file.type }
        );

        this.courseService.uploadFile(modifiedFile, CourseConstants.SessionAttachmentFolderName)
          .subscribe({
            next: (response) => {
              this.filesToSave.push(this.constructSessionAttachment(file, response));
              completedUploads++;

              if (completedUploads === this.files.length) {
                this.courseService.saveAttachments(sessionId, this.filesToSave)
                  .subscribe(() => {
                    this.showConfirmationMessage(CourseConstants.Severity_Success, successMessage);
                    this.isSessionManagementDataReload.emit(true);
                    this.courseService.closeAndResetSessionSlider$.next(false);
                  });
              }
            },
            error: (err) => {
              completedUploads++;

              this.messageService.add({
                severity: CourseConstants.Severity_Err,
                summary: `Failed to upload file: ${file.name}`,
                detail: err || SharedConstants.File_Upload_Failed_Error,
                sticky: true
              });

              if (completedUploads === this.files.length) {
                this.isSessionManagementDataReload.emit(true);
                this.courseService.closeAndResetSessionSlider$.next(false);
              }
            }
          });
      });
    }
  };

  if (this.isSessionEdit) {
    successMessage = CourseConstants.Session_Updated_Success;
    this.deleteFiles().subscribe(() => {
      uploadFiles();
    });
    return;
  }

  uploadFiles();
}

  private deleteAttachment = (fileNameToDelete: string) => {
    const savedAttachment = this.courseService.getCurrentSession()?.attachments?.find((attachment: SessionAttachmentDetails) => {
      return attachment.attachmentName.toLowerCase() === fileNameToDelete.toLowerCase();
    });

    if (
      this.isSessionEdit &&
      savedAttachment &&
      !this.attachmentsMarkedForDeletion.some((attachment) => attachment.fileId === savedAttachment.fileId)
    ) {
      this.attachmentsMarkedForDeletion.push(savedAttachment);
    }

    this.files = this.files.filter((file) => {
      return file.name != fileNameToDelete;
    });

    this.fileNamesForAddAndDeleteOperations =
      this.fileNamesForAddAndDeleteOperations.filter((fileName) => {
        return fileName != fileNameToDelete;
      });

    this.savedFiles = this.savedFiles.filter((fileName) => {
      return fileName != fileNameToDelete;
    });
  };
  private prepareDeletedAttachments = () => {
    this.deletedAttachments = [];
    let savedAttachments = cloneDeep(
      this.courseService.getCurrentSession()?.attachments);
    let deletedAttachments = savedAttachments?.filter((savedAttachment) => {
      return (
        this.fileNamesForAddAndDeleteOperations.indexOf(
          savedAttachment.attachmentName
        ) == -1
      );
    });
    const combinedDeletedAttachments = [...this.attachmentsMarkedForDeletion];

    if (!!deletedAttachments && deletedAttachments.length > 0) {
      deletedAttachments.forEach((attachment) => {
        if (!combinedDeletedAttachments.some((item) => item.fileId === attachment.fileId)) {
          combinedDeletedAttachments.push(attachment);
        }
      });
    }

    this.deletedAttachments = combinedDeletedAttachments;
  };

  private prepareAddedAttachments = () => {
    this.files = this.files.filter((file) => {
      return this.savedFiles.indexOf(file.name) === -1;
    });
  };

  private calculateSavedFiles = () => {
    this.savedFiles = [];
    this.fileNamesForAddAndDeleteOperations = [];
    this.attachmentsMarkedForDeletion = [];

    this.courseService.getCurrentSession()?.attachments?.forEach(
      (attachment: SessionAttachmentDetails) => {
        this.savedFiles.push(attachment.attachmentName);
        this.fileNamesForAddAndDeleteOperations.push(attachment.attachmentName);
      }
    );
    this.fileUploadedEnabled = true;
  };
  private constructSessionAttachment = (file: File, fileSaveResponse: any): SessionAttachmentDetails => {
    return {
      fileId: fileSaveResponse.fileId,
      sessionId: this.sessionId,
      attachmentName: file.name,
      attachmentType: fileSaveResponse.fileExtension,
      attachmentPath: fileSaveResponse.filePath
    }
  }
  showConfirmationPopupForDeletedAttachments = () => {
    const uploadedFileNames = this.files.map((file) => file.name.toLowerCase());
    this.deletedAttachmentsForConfirmation = this.deletedAttachments.filter((attachment) => {
      return uploadedFileNames.indexOf(attachment.attachmentName.toLowerCase()) === -1;
    });

    if (this.deletedAttachmentsForConfirmation.length > 0) {
      this.showDeletedFilesConfirmationModal = true;
    }
  };

  closeConfirmationModal = () => {
    this.showDeletedFilesConfirmationModal = false;
  };
  updateSession = () => {
    this.showDeletedFilesConfirmationModal = false;
    this.verifyIfCourseContainsInActiveAGForUpdate(this.sessionDetails);
  }

  deleteFiles = (): Observable<void> => {
    this.filesToDelete = [];
    let deletedFiles = this.deletedAttachments;
    if (!!deletedFiles && deletedFiles.length > 0) {
      return forkJoin(
        deletedFiles.map((deletedAttachment: SessionAttachmentDetails) =>
          this.courseService.deleteFile(deletedAttachment.fileId).pipe(
            catchError(() => of(false))
          )
        )
      ).pipe(
        switchMap((results: boolean[]) => {
          this.filesToDelete = deletedFiles
            .filter((_, index) => !!results[index])
            .map((deletedAttachment) => deletedAttachment.attachmentId || '');

          if (this.filesToDelete.length > 0) {
            return this.courseService.deleteSessionAttachments(this.sessionId, this.filesToDelete).pipe(
              map(() => void 0)
            );
          }

          return of(void 0);
        })
      );
    }

    return of(void 0);
  }

  showConfirmationMessage = (severityMessage: string, summaryMessage: string) => {
    this.messageService.add({
      severity: severityMessage,
      summary: summaryMessage,
    });
  }

  private enableOrDisableControlsByFormatInptut = (formatValue: number | null) => {

    if (formatValue == CourseConstants.session_Format_InPerson_Value) {
      this.disableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
      this.ifFormatIsInPerson = false;
    }
    else {
      this.enableControls(CourseConstants.SessionFormControls_VirtualMeetingURL);
      this.ifFormatIsInPerson = true;
    }
    if (formatValue == CourseConstants.Session_Format_Virtual_Value) {
      this.disableControls(CourseConstants.SessionFormControls_Room);
      this.ifFormatIsVirtual = false;
    }
    else {
      this.enableControls(CourseConstants.SessionFormControls_Room);
      this.ifFormatIsVirtual = true;
    }
  }

  formatDateTimeToISOString(date: Date): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based, so add 1
    const day = String(date.getDate()).padStart(2, '0'); // Pad day with leading zero if necessary
    const hours = String(date.getHours()).padStart(2, '0');
    const minutes = String(date.getMinutes()).padStart(2, '0');
    const seconds = String(date.getSeconds()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}`;
  }
}
